import colors from 'vuetify/es5/util/colors'

let colorlist = [
    //{ title: 'blue', color: colors.blue, colorname: 'blue', hex: '#2196F3' },
    //{ title: 'Green', color: colors.green, colorname: 'green', hex: '#4caf50' },
    { title: 'blue.darken2', color: colors.blue.darken2, colorname: 'blue.darken2', hex: '#1976D2' },
    { title: 'green.darken1', color: colors.green.darken1, colorname: 'green.darken1', hex: '#43A047' },
    { title: 'Cyan', color: colors.cyan, colorname: 'cyan', hex: '#00bcd4' },  
    { title: 'purple.darken4', color: colors.purple.darken3, colorname: 'purple.darken4', hex: '#4A148C' },
    { title: 'Brown', color: colors.brown, colorname: 'brown', hex: '#795548' },
    { title: 'blueGrey.darken2', color: colors.blueGrey.darken2, colorname: 'blueGrey.darken2', hex: '#455A64' },
    { title: 'grey.darken4', color: colors.grey.darken4, colorname: 'grey.darken4', hex: '#212121' },
]

export default colorlist